import { connect, useDispatch } from 'react-redux';
import { fazendaCertificadoAction } from '../_actions';
import React, { useEffect, useState } from 'react';
import NavBar from '../_components/navbar';
import DataTable from 'react-data-table-component';
import { withRouter } from '../_helpers/withRouter';
import { Container, Row, Col, Card, CardBody, CardHeader, Input, Badge } from 'reactstrap';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatCnpj, stringUtils } from '../_utils';

const drawerWidth = 240;

const CertificadosVencimento = (props) => {
    const dispatch = useDispatch();
    const certificados = props.certificado?.fazendaCertificado || [];
    const [term, setTerm] = useState('');

    useEffect(() => {
        dispatch(fazendaCertificadoAction.getCertificadosAVencer());
    }, []);

    useEffect(() => {
        console.log("Certificados carregados:", certificados);
    }, [certificados]);

    const handleChange = prop => event => {
        setTerm(event.target.value);
    };

    const conditionalRowStyles = [
        {
            when: row => new Date(row.data_validade) < new Date(),
            style: {
                backgroundColor: '#fff5f5',
            },
        },
        {
            when: row => {
                const dt = new Date(row.data_validade);
                const diffDays = Math.ceil((dt - new Date()) / (1000 * 60 * 60 * 24));
                return diffDays > 0 && diffDays <= 30;
            },
            style: {
                backgroundColor: '#fffbea',
            },
        }
    ];

    const columnsCertificados = [
        {
            name: 'Nome do Certificado',
            selector: row => row?.nome || '',
            sortable: true,
        },
        {
            name: 'Chave',
            selector: row => formatCnpj(row.chave || ''),
            sortable: true,
        },
        {
            name: 'Data de Cadastro',
            selector: row => stringUtils.formatDataHora(row?.data_cadastro || ''),
            sortable: true,
        },
        {
            name: 'Data de Validade',
            selector: row => row?.data_validade || '',
            cell: row => {
                const dt = new Date(row?.data_validade || '');
                const dataFormatada = dt.toLocaleDateString('pt-BR');
                const hoje = new Date();
                const venceu = dt < hoje;
                const corIcone = venceu ? '#FF0000' : '#FFC107';
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span>{dataFormatada}</span>
                        <AccessTimeIcon style={{ color: corIcone }} />
                    </div>
                );
            },
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => {
                const dt = new Date(row?.data_validade || '');
                const diffDays = Math.ceil((dt - new Date()) / (1000 * 60 * 60 * 24));
                if (dt < new Date()) return -1;
                return diffDays;
            },
            cell: row => {
                const dt = new Date(row?.data_validade || '');
                const diffDays = Math.ceil((dt - new Date()) / (1000 * 60 * 60 * 24));
                if (dt < new Date()) {
                    return <Badge color="danger">Vencido</Badge>;
                } else if (diffDays <= 30) {
                    return <Badge color="warning">Faltam {diffDays} dia(s)</Badge>;
                } else {
                    return <Badge color="success">Válido</Badge>;
                }
            },
            sortable: true,
            right: true,
        }
    ];

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card className="mt-4">
                    <CardHeader>
                        <h5 className="left">Certificados vencendo em até 30 dias</h5>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <Input
                                    id="term"
                                    label="term"
                                    placeholder="Filtro por nome ou chave"
                                    value={term}
                                    onChange={handleChange('term')}
                                />
                            </Col>
                        </Row>
                        <br />
                        <DataTable
                            title=""
                            columns={columnsCertificados}
                            pagination
                            striped
                            noDataComponent="Sem certificados próximos do vencimento"
                            paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                            conditionalRowStyles={conditionalRowStyles}
                            highlightOnHover
                            data={certificados.filter((item) => {
                                if (term === '') {
                                    return item;
                                } else if (item.nome?.toLowerCase().includes(term.toLowerCase())) {
                                    return item;
                                } else if (formatCnpj(item.chave || '').toLowerCase().includes(term.toLowerCase())) {
                                    return item;
                                }
                            })}
                        />
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );
};


const mapStateToProps = (state) => {
    return {
        certificado: state.fazendaCertificado
    };
};

const connectedPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(CertificadosVencimento));

export { connectedPage as CertificadosAVencer };
